<template>
    <v-col md="4" v-if="layoutOrientation === 'vertical'">
        <v-file-input
            v-model="treatmentsFile"
            label="Treatments File"
            accept="xlsx"
        />
        <v-btn
            color="primary"
            @click="downloadTreatmentsSetupFile"
        >
            Download Template Excel Setup File
        </v-btn>
    </v-col>
    <v-row md="4" no-gutters justify="end" v-else>
        <v-col cols="5">
            <v-file-input
                v-model="treatmentsFile"
                label="Treatments File"
                accept="xlsx"
            />
        </v-col>
        <v-btn
            v-if="!treatmentsFile"
            class="ms-2 mt-3"
            variant="elevated"
            @click="downloadTreatmentsSetupFile"
        >
            Download Template
        </v-btn>
        <v-btn
            class="ms-2 mt-3"
            color="primary"
            variant="elevated"
            :disabled="_.isNil(treatmentsFile)"
            @click="uploadTreatmentsSetupFile"
        >
            Upload File
        </v-btn>
        <v-btn
            class="ms-2 mt-3"
            variant="outlined"
            @click="onCancel"
        >
            Cancel
        </v-btn>
    </v-row>
</template>
<script setup lang="ts">
import _ from 'lodash';
import { withLoadingScreen } from "@/lib/loading";
import { treatmentsAPI } from "@/services/treatments/treatmentsAPI";
import { downloadFile } from "@/lib/downloadFileUtil";

const { layoutOrientation, experimentCode } = defineProps<{
    layoutOrientation: "horizontal" | "vertical";
    experimentCode?: string;
}>();

const emit = defineEmits<{
    (e: "fileSubmitted"): void;
    (e: "onCancel"): void;
}>();

const treatmentsFile = defineModel<File | null>();

async function downloadTreatmentsSetupFile() {
    await withLoadingScreen(async () => {
        const response = await treatmentsAPI.fetchTreatmentsSetupFile(experimentCode);
        downloadFile(`Treatments-Setup.xlsx`, response);
    });
}

function onCancel() {
    emit("onCancel");
}

function uploadTreatmentsSetupFile() {
    emit("fileSubmitted");
}

</script>
